package team.platforma.dictionarydata.database

import app.cash.sqldelight.SuspendingTransacter
import app.cash.sqldelight.db.QueryResult
import app.cash.sqldelight.db.SqlDriver
import app.cash.sqldelight.db.SqlSchema
import kotlin.Unit
import team.platforma.dictionarydata.database.dictionarydata.newInstance
import team.platforma.dictionarydata.database.dictionarydata.schema
import team.platforma.dictionarydata.table.AiChapterQueries
import team.platforma.dictionarydata.table.AiModelQueries

public interface DictionaryDatabase : SuspendingTransacter {
  public val aiChapterQueries: AiChapterQueries

  public val aiModelQueries: AiModelQueries

  public companion object {
    public val Schema: SqlSchema<QueryResult.AsyncValue<Unit>>
      get() = DictionaryDatabase::class.schema

    public operator fun invoke(driver: SqlDriver): DictionaryDatabase =
        DictionaryDatabase::class.newInstance(driver)
  }
}
